import { render, staticRenderFns } from "./SeStdTaxForm4684.vue?vue&type=template&id=9b8691ba"
import script from "./SeStdTaxForm4684.vue?vue&type=script&lang=js"
export * from "./SeStdTaxForm4684.vue?vue&type=script&lang=js"
import style0 from "./SeStdTaxForm4684.vue?vue&type=style&index=0&id=9b8691ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports